import { isEqual } from 'lodash'
import { useRef } from 'react'

// lifted from hook used internally by apollo-client
// https://github.com/apollographql/apollo-client/blob/f20e114b8982837f118fa639ab2fbcb631d6b824/src/react/hooks/utils/useDeepMemo.ts#L11-L22
function useDeepMemo<TKey, TValue>(memoFn: () => TValue, key: TKey): TValue {
  const ref = useRef<{ key: TKey; value: TValue }>()

  if (!ref.current || !isEqual(key, ref.current.key)) {
    ref.current = { key, value: memoFn() }
  }

  return ref.current.value
}
export default useDeepMemo
